import { render } from "./InvoiceRequest.vue?vue&type=template&id=31088a71&ts=true"
import script from "./InvoiceRequest.vue?vue&type=script&lang=ts"
export * from "./InvoiceRequest.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__